import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../notification/notification.service';

const SILENT_PATHS = ['/api/auth/', '/api/quotes/', '/api/config/', '/api/me'];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notify = inject(NotificationService);
  const translate = inject(TranslateService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const url = error.url ?? req.url;
      const silent = SILENT_PATHS.some((p) => url.includes(p));
      if (silent) return throwError(() => error);

      if (error.status === 403) {
        notify.error(translate.instant('shared.error.forbidden'));
      } else if (error.status === 0 || error.status === 408 || error.status === 504) {
        notify.error(translate.instant('shared.error.network'));
      } else if (error.status >= 500) {
        notify.error(translate.instant('shared.error.server'));
      }

      return throwError(() => error);
    }),
  );
};
